<template>
  <div class="payment-records">
    <div class="search">
      <div class="left">
        <xl-input
          class="input-width"
          :placeholder="$t('design.creditCard.paymentCaseCode') || '案例编号'"
          v-model="searchParam.orderID"
          size="large"
          @keydown.enter="searchPayment"
        >
          <template #suffix>
            <SearchBlod @click="searchPayment"></SearchBlod>
          </template>
        </xl-input>
        <xl-select
          class="select-width"
          :placeholder="$t('design.creditCard.paymentChannel') || '支付渠道'"
          v-model="searchParam.payChannel"
          :options="payTypeList"
          size="large"
          clearable
          @change="searchPayment"
        >
        </xl-select>
        <!-- <xl-select
          class="select-width"
          :placeholder="$t('design.creditCard.payBrand') || '支付品牌'"
          v-model="searchParam.payBrand"
          :options="payBrandList"
          size="large"
          clearable
          @change="search"
        >
        </xl-select> -->
        <!-- <xl-input
          class="input-width"
          :placeholder="$t('design.creditCard.paymentCardNumber') || '支付卡号'"
          v-model="searchParam.cardNumber"
          @keydown.enter="search"
          size="large"
        >
          <template #suffix>
            <SearchBlod></SearchBlod>
          </template>
        </xl-input> -->
        <!-- <xl-select
          class="select-width"
          :placeholder="$t('design.creditCard.invoiceIsRequired') || '是否开票'"
          v-model="searchParam.invoiceRequired"
          @keydown.enter="search"
          size="large"
        >
        </xl-select> -->
        <xl-date-picker
          size="large"
          type="daterange"
          v-model="searchParam.payDateRange"
          :start-placeholder="$t('design.creditCard.paymentStartDate') || '支付开始日期'"
          :end-placeholder="$t('design.creditCard.paymentEndDate') || '支付结束日期'"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
          @change="searchPayment"
          unlink-panels
          clearable
        >
        </xl-date-picker>
        <xl-divider class="" direction="vertical" />
        <xl-button class="button-width" size="large" @click="handleReset">
          <xl-icon name="zhongzhishitu1"></xl-icon>
          <span>{{$t('design.reset') || '重置'}}</span>
        </xl-button>
      </div>
      <div class="right">
        <xl-button class="button-width export-width" size="large" @click="handleExport">
          <xl-icon name="upload"></xl-icon>
          <span>{{$t('design.export') || "导出"}}</span>
        </xl-button>
      </div>
    </div>
    <div class="table" ref="containerRef">
      <xl-table :data="tableData" :headers="headers" height="100%" @sort-change="handleChangeTableSort" :emptyText="$t('design.noData')">
        <xl-table-column
          prop="id"
          align="left"
          :label="$t('design.creditCard.paymentCode') || '支付编号'"
          show-overflow-tooltip
          minWidth='150'
        >
          <template #default="{ row }">
            <span>{{ row.id || "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="orderId"
          align="left"
          :label="$t('design.creditCard.paymentCaseCode') || '案例编号'"
          show-overflow-tooltip
          minWidth='150'
        >
          <template #default="{ row }">
            <span>{{ row.orderId || "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="payChannel"
          align="left"
          :label="$t('design.creditCard.paymentChannel') || '支付渠道'"
          show-overflow-tooltip
          minWidth='120'
        >
          <template #default="{ row }">
            <span>{{ row.payChannel || "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="payAccount"
          align="left"
          :label="$t('design.creditCard.payBrand') || '支付品牌'"
          show-overflow-tooltip
          minWidth='150'
        >
          <template #default="{ row }">
            <span>{{ payBrandMap[row.payBrand] || row.payBrand || "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="actualTotal"
          align="left"
          :label="$t('design.creditCard.paymentAmountOrPoint') || '支付数额'"
          show-overflow-tooltip
          minWidth='200'
        >
          <template #default="{ row }">
            <span v-if="row.currency === 'CREDITS'">{{ $t('design.point.pointNum', { point: row.actualTotal }) || "-" }}</span>
            <span v-else>{{ formatPrice(row.actualTotal) + ' ' + row.currency || "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="payName"
          align="left"
          :label="$t('design.creditCard.payName') || '支付人'"
          show-overflow-tooltip
          minWidth='140'
        >
          <template #default="{ row }">
            <span>{{ row.payName || "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="payAccount"
          align="left"
          :label="$t('design.creditCard.payAccount') || '支付账号'"
          show-overflow-tooltip
          minWidth='220'
        >
          <template #default="{ row }">
            <span>{{ row.payAccount || "-" }}</span>
          </template>
        </xl-table-column>
        <!-- <xl-table-column
          prop="cardNumber"
          align="left"
          :label="$t('design.creditCard.paymentCardNumber') || '支付卡号'"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <div>{{ row.cardNumber || "-" }}</div>
          </template>
        </xl-table-column> -->
        <xl-table-column
          prop="actualPayOn"
          sortable="custom"
          align="left"
          :label="$t('design.creditCard.paymentDateRange') || '支付时间'"
          show-overflow-tooltip
          minWidth="180"
        >
          <template #default="{ row }">
            <span>{{ row.actualPayOn && row.actualPayOn?.split('-')?.[0] !== '1970' ? $convertUTCDateToLocalDate(row.actualPayOn) : "-" }}</span>
          </template>
        </xl-table-column>
        <xl-table-column
          prop="payStatus"
          align="left"
          :label="$t('design.status') || '状态'"
          show-overflow-tooltip
          minWidth='140'
          fixed="right"
        >
          <template #default="{ row }">
            <div>
              <xl-tag v-if="row.payStatus==='success'" type="success">{{ payStatusMap.get(row.payStatus) || '-' }}</xl-tag>
              <xl-tag v-if="row.payStatus==='cancel'" type="info">{{ payStatusMap.get(row.payStatus) || '-' }}</xl-tag>
              <xl-tag v-if="row.payStatus==='paying'" type="primary">{{ payStatusMap.get(row.payStatus) || '-' }}</xl-tag>
              <xl-tag v-if="row.payStatus==='fail'" type="danger">{{ payStatusMap.get(row.payStatus) || '-' }}</xl-tag>
            </div>
          </template>
        </xl-table-column>
        <!-- <xl-table-column
          prop="invoiceRequired"
          align="left"
          :label="$t('design.creditCard.invoiceIsRequired') || '是否开票'"
          show-overflow-tooltip
          width='100'
        >
          <template #default="{ row }">
            <div>{{ row.invoiceRequired || "-" }}</div>
          </template>
        </xl-table-column> -->
      </xl-table>
    </div>
    <xl-pagination
      v-model:page="pageInfo.page"
      v-model:pageSize="pageInfo.pageSize"
      :total="pageInfo.total"
      @pageSizeChange="search"
      @pageChange="search"
      >
    </xl-pagination>
  </div>
</template>

<script setup>
import {
  XlButton,
  XlTable,
  XlTableColumn,
  XlDivider,
  XlSelect,
  XlMessageBox,
  XlPagination,
  XlTag,
  XlFormItem,
  XlForm,
  XlInput,
  XlDatePicker,
  XlIcon,
  XlMessage,
  XlLoading
} from "@shining3d/ui-components";
import { ref, reactive, computed, onMounted, defineExpose, defineProps } from "vue";
import { SearchBlod } from "@shining3d/icons-vue";
import creditCardApi from "../../api/creditCard/index.js";
import { useLang } from '@shining3d/common-module/utils/lang.js';
import { $convertUTCDateToLocalDate, $convertLocalDateToUTCDate, formatPrice } from '../../utils/common.js';
import { cardList } from '../../common/enum.js';

// import { payStatusMap } from '../../common/enum';
import _get from 'lodash/get';
import { cloneDeep } from "lodash";
import { useStore } from "vuex";
import { VueCookieNext } from 'vue-cookie-next';

const $store = useStore();
const { $t } = useLang( '@shining3d/xl-design-order' );

const props = defineProps({
  cardNo: {
    type: String,
    default: '',
  },
  platform: {
    type: String
  }
});

const payBrandMap = cardList.reduce((obj, cur) => {
  obj[cur.value] = cur.label;
  return obj;
}, {});

const pageInfo = ref({
  page: 1,
  pageSize: 20,
  total: 0,
  pages: 0
});

const initSearchParam = {
  orderID: "", // 案例编号
  payChannel: "", // 支付渠道
  // status: '', // 支付状态
  actualPayOnStart: '', // 实际支付开始时间
  actualPayOnEnd: '', // 实际支付结束时间
  payDateRange: [],
  orderByName: '',
  orderBy: '', 
  payBrand: '' // 支付品牌
  // cardNumber: "", // 支付卡号
  // invoiceRequired: "", // 是否开票
};

const searchParam = ref(cloneDeep(initSearchParam));
const headers = ref([]);
// 支付渠道
const payTypeList = [
  {
    label: 'airwallex',
    value: 'airwallex'
  },
  {
    label: 'SHINING3D',
    value: 'SHINING3D'
  },
  // {
  //   label: 'Visa',
  //   value: 'visa'
  // },
  // {
  //   label: 'Master card',
  //   value: 'mastercard'
  // }
]
// 支付品牌
const payBrandList = [
{
    label: 'aliPay',
    value: 'aliPay'
  },
  {
    label: 'wechatPay',
    value: 'wechatPay'
  },
  {
    label: 'visa',
    value: 'visa'
  },
  {
    label: 'mastercard',
    value: 'mastercard'
  }
]
const tableData = ref([]);
// 支付状态枚举
const payStatusMap = new Map([
    ['success', $t('design.creditCard.PaymentSuccess')],
    ['fail', $t('design.creditCard.PaymentFail')],
    ['cancel', $t('design.creditCard.PaymentCancel')],
    ['paying', $t('design.creditCard.PaymentPaying')]
])
const tableLoading = ref(false);
// 机构id
const institutionId = computed(() => {
  let id = _get( $store, 'state.factorySelect.id', '');
  if ( props.platform === 'designerService') {
    id = _get( $store, 'state.factoryID', '');
  }
  return id;
});
const containerRef = ref(null);
const loadingInstance = ref(null);
//获取支付列表
const getPaymentList = () => {
  if ( loadingInstance.value ) {
		loadingInstance.value?.close();
	}
	loadingInstance.value = XlLoading.service({
		target: containerRef.value,
		background: 'rgba(255,255,255,0.9)',
	});
  creditCardApi.getPaymentList({
    ...searchParam.value,
    ...pageInfo.value,
    actualPayOnStart: searchParam.value?.payDateRange?.[0] ? $convertLocalDateToUTCDate( searchParam.value.payDateRange[0] + ' 00:00:00' ) : '',
    actualPayOnEnd: searchParam.value?.payDateRange?.[1] ? $convertLocalDateToUTCDate( searchParam.value?.payDateRange[1] + ' 23:59:59' ) : '',
    businessID: institutionId.value,
    platform: window.app?.entryName || 'dental',
    cardNo: cardNo.value
  }).then((res) => {
    if( res && res.status === 'success' ){
      tableData.value = res.result || [];
      pageInfo.value = res.pageInfo;
    }
    loadingInstance.value?.close();
  })
};

const searchPayment = () => {
  pageInfo.page = 1;
  cardNo.value = ''; // 积分卡置空
  getPaymentList();
};

const search = () => {
  getPaymentList();
}
const handleReset = () => {
  cardNo.value = '';
  searchParam.value = cloneDeep(initSearchParam);
  pageInfo.value.page = 1;
  getPaymentList();
};
// const handleSearch = () => {
//   getPaymentList();
// };
// 排序
const handleChangeTableSort = ( column ) => {
  if ( column.prop === 'actualPayOn' ) {
    searchParam.value.orderByName = 'actualPayOn';
  } else {
    searchParam.value.orderByName = '';
  }
  if ( column.order === 'ascending' ) {
		searchParam.value.sortType = 'asc'
	} else if ( column.order === 'descending' ){
		searchParam.value.sortType = 'desc';
	} else {
		searchParam.value.sortType = '';
	}
  search();
}
const downloadFile = ( data, name ) => {
	const binaryString = window.atob( data );
	const binaryLen = binaryString.length;
	const bytes = new Uint8Array( binaryLen );
	// eslint-disable-next-line no-plusplus
	for ( let i = 0;i < binaryLen;i++ ) {
		const ascii = binaryString.charCodeAt( i );
		bytes[ i ] = ascii;
	}
	const blob = new Blob([bytes], { type: 'application/vnd.ms-excel' });
	const URL = window.URL.createObjectURL( blob );
	const listNode = document.createElement( 'a' );
	listNode.download = name + '.xlsx';
	listNode.style.display = 'none';
	listNode.href = URL; // 文件流生成的url
	document.body.appendChild( listNode );
	listNode.click(); // 模拟在按钮上实现一次鼠标点击
	window.URL.revokeObjectURL( listNode.href );
	document.body.removeChild( listNode );
};
// 导出
const handleExport = () => {
  creditCardApi.exportPaymentList({
    ...searchParam.value,
    actualPayOnStart: searchParam.value?.payDateRange?.[0] ? $convertLocalDateToUTCDate( searchParam.value.payDateRange[0] + ' 00:00:00' ) : '',
    actualPayOnEnd: searchParam.value?.payDateRange?.[1] ? $convertLocalDateToUTCDate( searchParam.value?.payDateRange[1] + ' 23:59:59' ) : '',
    businessID: institutionId.value,
    platform: window.app?.entryName || 'dental',
    cardNo: cardNo.value,
    lang: VueCookieNext.getCookie('lang')
  }).then((res) => {
    if( res && res.status === 'success' ){
      const fileName =
				new Date().toLocaleDateString().
					replace( /\//g, '-' ) + '-paymentRecords';
      downloadFile( res.result, fileName );
    }
  })
}

// 积分卡支付记录筛选
const cardNo = ref('');
const searchPoint = ( id ) => {
  cardNo.value = id;
  searchParam.value = cloneDeep(initSearchParam);
  pageInfo.value.page = 1;
  
  getPaymentList();
};

onMounted(() => {
  // handleSearch();
  if ( props.cardNo ){
    cardNo.value = props.cardNo;
  }
  search();
})

defineExpose({ searchPoint })
</script>

<style lang="scss" scoped>
.payment-records {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;
  .search {
    flex-grow: 0;
    flex-shrink: 0;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    .margin8 {
      margin-left: 8px;
    }
    .left {
      display: flex;
      align-items: center;
      margin: -8px 8px 0 -8px;
      & > * {
        margin: 8px 0 0 8px;
      }
      .input-width {
        max-width: 120px;
      }
      .select-width {
        max-width: 160px;
      }
      :deep(.xl-date-picker.el-date-editor) {
        width: 330px;
        margin-left: 8px;
        margin-top: 8px;
      }
      :deep(.el-date-editor .el-range-separator){
        flex: 0;
      }
    }
    .right {
      flex-grow: 0;
      flex-shrink: 0;
    }
    .button-width {
      // width: 88px;
      padding: 0 16px !important;
      .xl-icon {
        margin-right: 4px;
      }
      &:hover{
        .xl-icon {
          color: #5587FF !important;
          background: #ffffff !important;
        }
      }
    }
    .export-width{
      // min-width: 94px !important;
      i{
        padding: 0 !important;
      }
    }
    :deep(.el-divider) {
      height: 20px;
      color: #e0e4ea;
    }
  }
  .table {
    width: 100%;
    height: calc(100% - 200px);
    margin: 16px 0 7px;
    box-sizing: border-box;
    overflow: auto;
    flex-grow: 1;
    position: relative;
    :deep(.xl-table) {
      flex-grow: 1;
    }
    .submitted {
      padding-left: 18px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 1px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-top: -4px;
        background-color: #0fbd81;
      }
      &.submitted-not::before {
        background-color: #a5acbe;
      }
    }
  }
  :deep(.xl-pagination) {
    // margin-right: 16px;
    flex-grow: 0;
    flex-shrink: 0;
  }
  .operate {
    cursor: pointer;
    width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 20px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    &:not(:first-of-type) {
      margin-left: 8px;
    }
  }
  .edit-icon {
    margin-left: 8px;
    display: inline-block;
    height: 28px;
    line-height: 28px;
  }
  .disabled-edit {
    opacity: 0.4;
    cursor: not-allowed;
    .iconfont {
      pointer-events: none;
    }
  }
  :deep(.xl-table.el-table .xl-table-empty) {
    min-height: 0 !important;
  }
  .xl-pagination{
    position: relative;
  }
  :deep(.el-scrollbar__view){
    height: 100%;
  }
}
</style>
